export const WaterPhaseValue = {
  ice: 1,
  liquid: 0,
  unknown: 2,
} as const;

export type WaterPhaseValue =
  (typeof WaterPhaseValue)[keyof typeof WaterPhaseValue];
